
import React, { Component, } from 'react';
import Header from './components/header'
import Footer from './components/footer'
import PageTilte from './components/pageTilte';
import GoogleMap from './components/contact/googleMap';
import moment from 'moment-jalaali';
import { constantApp } from '../../config/constant';
const axios = require('axios');

class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: 'info@apafan.com',
            tel: '98-35-37263321+',
            hours: 'شنبه تا چهارشنبه از ساعت ۷:۳۰ تا ۱۵:۰۰',
            hours1: 'پنجشنبه ۷:۳۰ تا ۱۴:۰۰',
            adres: 'یزد، خیابان شهید مطهری، مرکز فناوری اقبال، سالن موسسات، واحد C5',

            newCustomer: {
                DateSabt: moment().format('jYYYY/jMM/jDD'),
                TimeSabt: moment().format("HH:mm"),
                nam: '',
                famil: '',
                email: '',
                mobile: '',
                message: '',
            },

            ErrorCustomer: {
                nam: false,
                famil: false,
                email: false,
                mobile: false,
                message: false,
            },
            isSaving: false,
        }

        this.initialState = { ...this.state }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.timer = this.timer.bind(this)
    }


    isError() {

        if (this.state.ErrorCustomer.nam === true ||
            this.state.ErrorCustomer.famil === true ||
            this.state.ErrorCustomer.email === true ||
            this.state.ErrorCustomer.mobile === true ||
            this.state.ErrorCustomer.message === true
        ) {
            return true
        } else {
            return false
        }

    }


    InsertContact = (DateSabt, TimeSabt, nam, famil, email, mobile, message) => {

        let params = {
            DateSabt, TimeSabt, nam, famil, email, mobile, message
        }

        let url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/Contact/Insert.php`;


        axios.post(url, params)
        // .then(function (response) {
        //     return response.data;
        // })
        // .catch(function (error) {

        // });



    }




    handleSubmit = async (event) => {
        event.preventDefault();
        const { DateSabt, TimeSabt, nam, famil, email, mobile, message } = this.state.newCustomer;

        if (nam.trim() === '') {
            this.setState({ ErrorCustomer: { nam: true } })
            return;
        }

        if (famil.trim() === '') {
            this.setState({ ErrorCustomer: { famil: true } })
            return;
        }


        if (mobile.trim() === '') {
            this.setState({ ErrorCustomer: { mobile: true } })
            return;
        } else if (mobile.trim().length < 9) {
            this.setState({ ErrorCustomer: { mobile: true } })
            return;
        }

        let emailValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
        if (email.trim() === '' || emailValid === null) {
            this.setState({ ErrorCustomer: { email: true } })
            return;
        }

        if (message.trim() === '') {
            this.setState({ ErrorCustomer: { message: true } })
            return;
        }


        await this.InsertContact(DateSabt, TimeSabt, nam, famil, email, mobile, message);


        this.setState(this.initialState);
        this.setState({ isSaving: true })
    }


    handleChange(e) {
        // let target = e.target;
        // let value = target.type === 'checkbox' ? target.checked : target.value;
        // let name = target.name;

        // this.setState({
        //     [name]: value
        // });



        let value = e.target.value;

        let name = e.target.name;

        this.setState(prevState => ({
            ErrorCustomer: { ...prevState.ErrorCustomer, [name]: false },
            newCustomer: { ...prevState.newCustomer, [name]: value }
        }), () => null)


    }


    timer() {
        if (this.state.isSaving) {
            this.setState({ isSaving: false })
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        this.intervalId = setInterval(this.timer.bind(this), 8000);
    }
    componentWillUnmount() {
        clearInterval(this.intervalId);
    }





    render() {

        return (
            <div className="page-wrapper">

                <Header />

                <PageTilte title={'تماس با ما'} />


                <section className="contact-pg-section section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col col-md-3">
                                <div className="contact-info">
                                    <ul>
                                        <li>
                                            <div className="icon"><i className="fa fa-phone"></i></div>
                                            <p><span>تلفن</span> {this.state.tel} </p>
                                        </li>
                                        <li>
                                            <div className="icon"><i className="fa fa-envelope"></i></div>
                                            <p><span>ایمیل</span>{this.state.email} </p>
                                        </li>
                                        <li>
                                            <div className="icon"><i className="fa fa-clock-o"></i></div>
                                            <p><span>ساعات کاری:</span>{this.state.hours}<br />{this.state.hours1}</p>
                                        </li>
                                        <li>
                                            <div className="icon"><i className="fa fa-location-arrow"></i></div>
                                            <p><span>دفتر</span>{this.state.adres}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <GoogleMap />

                        </div>
                        <div className="row">
                            <div className="col col-xs-12">
                                <form className="contact-form form contact-validation-active row" onSubmit={this.handleSubmit} noValidate>
                                    <div className="col col-sm-6">
                                        <label htmlFor="nam">نام</label>
                                        <input type="text" className="form-control" name="nam" style={{ border: this.state.ErrorCustomer.nam ? '2px solid red' : null }} value={this.state.newCustomer.nam} onChange={this.handleChange} />
                                    </div>
                                    <div className="col col-sm-6">
                                        <label htmlFor="famil">نام خانوادگی</label>
                                        <input type="text" className="form-control" name="famil" style={{ border: this.state.ErrorCustomer.famil ? '2px solid red' : null }} value={this.state.newCustomer.famil} onChange={this.handleChange} />
                                    </div>
                                    <div className="col col-sm-6">
                                        <label htmlFor="email">ایمیل</label>
                                        <input type="email" className="form-control" name="email" style={{ border: this.state.ErrorCustomer.email ? '2px solid red' : null }} value={this.state.newCustomer.email} onChange={this.handleChange} />
                                    </div>
                                    <div className="col col-sm-6">
                                        <label htmlFor="mobile">شماره تلفن</label>
                                        <input type="text" className="form-control" name="mobile" style={{ border: this.state.ErrorCustomer.mobile ? '2px solid red' : null }} value={this.state.newCustomer.mobile} onChange={this.handleChange} />
                                    </div>
                                    <div className="col col-sm-12">
                                        <label htmlFor="message">پیام</label>
                                        <textarea className="form-control" name="message" style={{ border: this.state.ErrorCustomer.message ? '2px solid red' : null }} value={this.state.newCustomer.message} onChange={this.handleChange}  ></textarea>
                                    </div>
                                    <div className="col col-sm-12 submit-btn">
                                        <button className="theme-btn">ارسال</button>
                                        <div id="loader">
                                            <i className="fa fa-refresh fa-spin fa-3x fa-fw"></i>
                                        </div>
                                    </div>

                                    <div className="error-handling-messages">
                                        <div id="success" style={{ display: this.state.isSaving ? 'block' : 'none' }}>با سپاس از شما</div>
                                        <div id="error" style={{ display: this.isError() ? 'block' : 'none' }}  >لطفا فیلدها را تکمیل نمایید</div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>




                <Footer />


            </div>
        );
    }
}



export default Contact


